<section class="page-shell">
  <header class="page-header">
    <div>
      <p class="eyebrow">Technique</p>
      <h2>Demandes de purge investisseur</h2>
    </div>

    <oui-button
      type="outlined"
      iconSuffix="sync"
      [disabled]="loading()"
      (click)="reload()">
      Actualiser
    </oui-button>
  </header>

  @if (loading() && !page()) {
    <dbw-state-card
      title="Chargement"
      appearance="loading">
      <p>Lecture des demandes de purge en cours.</p>
    </dbw-state-card>
  } @else if (error() && !page()) {
    <dbw-state-card
      title="Erreur"
      appearance="error">
      <p>{{ error() }}</p>
    </dbw-state-card>
  } @else {
    <div class="content-grid">
      @if (error()) {
        <dbw-state-card
          title="Dernière erreur"
          appearance="error"
          [compact]="true">
          <p>{{ error() }}</p>
        </dbw-state-card>
      }

      <section class="dbw-card dbw-card--xl table-card">
        <div class="table-card__header">
          <div>
            <h5>Demandes</h5>
            <p>{{ page()?.totalCount ?? 0 }} demande(s) enregistrée(s).</p>
          </div>
        </div>

        @if ((page()?.items?.length ?? 0) === 0) {
          <div class="empty-state">Aucune demande de purge n'est enregistrée.</div>
        } @else {
          <div class="table-shell">
            <oui-table
              class="data-table"
              [lineSizing]="'dense'">
              <table
                mat-table
                [dataSource]="page()?.items ?? []">
                <ng-container matColumnDef="investor">
                  <th
                    mat-header-cell
                    *matHeaderCellDef>
                    Investisseur
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let row">
                    <a [routerLink]="appRoutePaths.atlas.investor(row.investorId)">#{{ row.investorId }}</a>
                  </td>
                </ng-container>

                <ng-container matColumnDef="request">
                  <th
                    mat-header-cell
                    *matHeaderCellDef>
                    Demande
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let row">
                    <div class="metric-stack">
                      <strong>#{{ row.id }}</strong>
                      <span>{{ row.executionId }}</span>
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="status">
                  <th
                    mat-header-cell
                    *matHeaderCellDef>
                    Statut
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let row">
                    <oui-tag
                      type="status"
                      [status]="row.statusLevel">
                      {{ getStatusLabel(row) }}
                    </oui-tag>
                  </td>
                </ng-container>

                <ng-container matColumnDef="requestedAt">
                  <th
                    mat-header-cell
                    *matHeaderCellDef>
                    Demandée
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let row">
                    {{ formatDate(row.startedAtUtc) }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th
                    mat-header-cell
                    *matHeaderCellDef>
                    Actions
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let row">
                    <div class="row-actions">
                      <oui-button
                        type="text"
                        iconSuffix="visibility"
                        (click)="openDetails(row)">
                        Inspecter
                      </oui-button>
                    </div>
                  </td>
                </ng-container>

                <tr
                  mat-header-row
                  *matHeaderRowDef="displayedColumns"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumns"></tr>
              </table>
            </oui-table>

            <mat-paginator
              [length]="page()?.totalCount ?? 0"
              [pageIndex]="page()?.pageIndex ?? pageIndex()"
              [pageSize]="page()?.pageSize ?? pageSize()"
              [pageSizeOptions]="pageSizeOptions"
              [showFirstLastButtons]="true"
              (page)="onPageChange($event)">
            </mat-paginator>
          </div>
        }
      </section>
    </div>
  }
</section>
